/* This file was generated automatically. Do not edit manually. */

export enum CustomerClassification {
    PaymasterAccount = 'PaymasterAccount',
    Blacklist = 'Blacklist',
    Media = 'Media',
    LoyaltyProgram = 'LoyaltyProgram',
    PreviousComplaint = 'PreviousComplaint',
    Returning = 'Returning',
    Staff = 'Staff',
    FriendOrFamily = 'FriendOrFamily',
    TopManagement = 'TopManagement',
    Important = 'Important',
    VeryImportant = 'VeryImportant',
    Problematic = 'Problematic',
    Cashlist = 'Cashlist',
    DisabledPerson = 'DisabledPerson',
    Military = 'Military',
    Airline = 'Airline',
    HealthCompliant = 'HealthCompliant',
    InRoom = 'InRoom',
    WaitingForRoom = 'WaitingForRoom',
    Student = 'Student',
}
